<div class="docx-viewer">
  <div class="status" *ngIf="loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Renderizando documento...</span>
  </div>
  <div class="status error" *ngIf="error">
    <i class="fa-solid fa-circle-exclamation"></i>
    <span>{{ error }}</span>
  </div>
  <div #container class="docx-container"></div>
</div>
